/**
 * Spacing scale (rem). 4px grid at the 16px (1rem) design size — always use
 * these tokens (or Chakra space props that map to them) for padding, gap,
 * and margin. Prefer multiples of 4 at the design size (`1` = 4px, `2` = 8px).
 *
 * Values are rem so they track the fluid `html` font-size (ENG-2281). Do not
 * put `px` sizes here except `px` itself (hairlines).
 */
export const space = {
	px: '1px',
	0.5: '0.125rem', // 2px
	1: '0.25rem', // 4px
	1.5: '0.375rem', // 6px
	2: '0.5rem', // 8px
	2.5: '0.625rem', // 10px
	3: '0.75rem', // 12px
	3.5: '0.875rem', // 14px
	4: '1rem', // 16px
	5: '1.25rem', // 20px
	6: '1.5rem', // 24px
	7: '1.75rem', // 28px
	8: '2rem', // 32px
	10: '2.5rem', // 40px
	12: '3rem', // 48px
	14: '3.5rem', // 56px
	16: '4rem', // 64px
	20: '5rem', // 80px
	24: '6rem', // 96px
} as const;

/**
 * Named layout sizes used by the app shell. Rem so they densify with the
 * fluid root. Prefer these (or `var(--partbay-*)`) over raw `64px` / `200px`.
 */
export const sizes = {
	topbar: '4rem',
	sidebar: '12.5rem',
	sidebarCollapsed: '4.5rem',
	sideDrawer: '32rem',
} as const;

/** Full-viewport page height under the top bar. */
export const SHELL_VIEWPORT_HEIGHT = 'calc(100dvh - var(--partbay-topbar))';

export default space;
